import { render, staticRenderFns } from "./RiskCheckCheckList.vue?vue&type=template&id=b43dda64&scoped=true"
import script from "./RiskCheckCheckList.vue?vue&type=script&lang=js"
export * from "./RiskCheckCheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43dda64",
  null
  
)

export default component.exports